import type { AdminProfile } from "@/core/types";
import { adminRequestsTyped } from "@/api/(requests)/adminTyped";

export async function getAdminProfileById(adminId: string): Promise<AdminProfile> {
  return adminRequestsTyped.fetch_admin_profile_by_id({ searchParams: { id: adminId } });
}
